import { render, staticRenderFns } from "./WrapperTour.vue?vue&type=template&id=1a7f2708&scoped=true"
import script from "./WrapperTour.vue?vue&type=script&lang=js"
export * from "./WrapperTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f2708",
  null
  
)

export default component.exports